<template>
    <div class="featured-offer absolute -top-2 -right-2 z-20">
        <span class="bg-black/[0.65] text-white rounded-full px-2.5 py-0.5 font-medium text-xs ml-1"
            ><i class="fas fa-bolt text-yellow-400 mr-2"></i>{{ text }}</span
        >
    </div>
</template>
<script>
export default {
    name: 'SpecialTag',
    props: {
        text: {
            type: String,
            default: 'Special Offer',
        },
    },
    data: () => ({}),
};
</script>
